@reference "@glow/tailwind-config/reference.css";

.badge {
  @apply rounded-full;
  @apply text-white;
  @apply text-center;
  @apply w-[18px];
  @apply h-[18px];
  @apply font-bold;
  @apply text-xs;
  @apply leading-[1.1rem];
}

.SUCCESS {
  @apply bg-success-dark;
}

.WARNING {
  @apply bg-warning-dark;
}

.DANGER {
  @apply bg-danger-dark;
}

.NEUTRAL {
  @apply bg-emphasis-high;
}

.LIGHT {
  @apply text-emphasis-high;
  @apply bg-gray-200;
}

.DARK {
  @apply bg-neutral-700;
}

.BLUE {
  @apply bg-blue-700;
}
